/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteAmountSummaryRequest
 */
export interface QuoteAmountSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QuoteAmountSummaryRequest
     */
    freelancerQuoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteAmountSummaryRequest
     */
    clientIdentityId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuoteAmountSummaryRequest
     */
    totalPriceExcludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof QuoteAmountSummaryRequest
     */
    vat?: number;
    /**
     * 
     * @type {Date}
     * @memberof QuoteAmountSummaryRequest
     */
    projectStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteAmountSummaryRequest
     */
    projectEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof QuoteAmountSummaryRequest
     */
    projectRenewalId?: string;
    /**
     * Per-line amounts excluding taxes, used to apply sum-of-tax strategy before the July 2026 cutoff when no quote ID is provided
     * @type {Array<number>}
     * @memberof QuoteAmountSummaryRequest
     */
    lineAmounts?: Array<number>;
}

/**
 * Check if a given object implements the QuoteAmountSummaryRequest interface.
 */
export function instanceOfQuoteAmountSummaryRequest(value: object): value is QuoteAmountSummaryRequest {
    return true;
}

export function QuoteAmountSummaryRequestFromJSON(json: any): QuoteAmountSummaryRequest {
    return QuoteAmountSummaryRequestFromJSONTyped(json, false);
}

export function QuoteAmountSummaryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteAmountSummaryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerQuoteId': json['freelancerQuoteId'] == null ? undefined : json['freelancerQuoteId'],
        'clientIdentityId': json['clientIdentityId'] == null ? undefined : json['clientIdentityId'],
        'totalPriceExcludingTaxes': json['totalPriceExcludingTaxes'] == null ? undefined : json['totalPriceExcludingTaxes'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'projectStartDate': json['projectStartDate'] == null ? undefined : (new Date(json['projectStartDate'])),
        'projectEndDate': json['projectEndDate'] == null ? undefined : (new Date(json['projectEndDate'])),
        'projectRenewalId': json['projectRenewalId'] == null ? undefined : json['projectRenewalId'],
        'lineAmounts': json['lineAmounts'] == null ? undefined : json['lineAmounts'],
    };
}

export function QuoteAmountSummaryRequestToJSON(value?: QuoteAmountSummaryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerQuoteId': value['freelancerQuoteId'],
        'clientIdentityId': value['clientIdentityId'],
        'totalPriceExcludingTaxes': value['totalPriceExcludingTaxes'],
        'vat': value['vat'],
        'projectStartDate': value['projectStartDate'] == null ? undefined : ((value['projectStartDate']).toISOString().substring(0,10)),
        'projectEndDate': value['projectEndDate'] == null ? undefined : ((value['projectEndDate']).toISOString().substring(0,10)),
        'projectRenewalId': value['projectRenewalId'],
        'lineAmounts': value['lineAmounts'],
    };
}

